import { makeReporter, ReportCommonArgs } from '@/utils/make-reporter'

function getCachedShowFrom (data: { [key: string]: number | string } & { show_from?: string }) {
  if (!data.show_from) {
    return sessionStorage.getItem('report_show_from')
  }

  return data.show_from
}

const pvReporter = makeReporter({
  business_index: 7543,
  show_from: 'team',
  ver: 0,
  page_pos: '',
  reserve: '',
})

const createTeamReporter = makeReporter({
  business_index: 7560,
  show_from: 'team',
  page_pos: '',
  team_name: '',
  team_num: '',
  ver: '',
})

export class Reporter {
  pvReporter (
    data: Partial<ReportCommonArgs & {
      business_index: number,
      show_from: string,
      ver: number,
      page_pos: string,
      reserve: string,
    }>
  ) {
    data.show_from = getCachedShowFrom(data)
    pvReporter(data)
  }

  clickReporter = makeReporter({
    business_index: 7751,
    action: 0,
    ver: 0,
    page_pos: '',
    result: 0,
    login: 0,
    show_from: 'team',
  })

  createTeamReporter (
    data: Partial<ReportCommonArgs & {
      business_index: number,
      show_from: string,
      ver: string,
      page_pos: string,
      reserve: string,
      team_name: string,
      team_num: string,
    }>
  ) {
    data.show_from = getCachedShowFrom(data)
    createTeamReporter(data)
  }
}
